import { useQueryCommands } from '../hooks/useQueryCommands.js'

import { CommandBarHotKey } from './CommandBarHotKey.js'

export const ActionItemsHotkeys = () => {
  const { actions } = useQueryCommands('')

  // traverse the actions and bind hotkeys
  return (
    <>
      {actions
        .filter(action => action?.hotkey)
        .map(actionItem => (
          <CommandBarHotKey
            key={`${actionItem.name}-${actionItem.category}`}
            actionItem={actionItem}
          />
        ))}
    </>
  )
}
